import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";


const Projects = () => {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  // تحميل البيانات من Firestore
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const q = query(collection(db, "projects"), orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const projectsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProjects(projectsData);
      } catch (error) {
        console.error("حدث خطأ أثناء تحميل المشاريع:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (loading) {
    return (
      <section style={styles.section}>
        <h2 style={styles.title}>إنجازاتنا / مشروعاتنا</h2>
        <p style={{ color: "#004aad", fontWeight: "600" }}>جارٍ التحميل...</p>
      </section>
    );
  }

  return (
    <section style={styles.section} id="projects">
      <h2 style={styles.title}>مشروعاتنا</h2>

      {projects.length === 0 ? (
        <p style={{ color: "#555", fontSize: "1rem" }}>لا توجد مشروعات حالياً</p>
      ) : (
        <div style={styles.grid}>
          {projects.map((project) => (
            <div key={project.id} style={styles.card}>
              <div style={styles.imageWrapper}>
                {project.imageUrl ? (
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    style={styles.image}
                  />
                ) : (
                  <div style={styles.noImage}>لا توجد صورة</div>
                )}
              </div>
              <div style={styles.content}>
                <h3 style={styles.cardTitle}>{project.title}</h3>
                <button
  style={styles.button}
  onClick={() => navigate(`/projects/${project.id}`)}
>
  اعرف المزيد
</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: "#ffffff",
    padding: "80px 20px",
    textAlign: "center",
    direction: "rtl",
    fontFamily: "Cairo, sans-serif",
  },
  title: {
    fontSize: "2.3rem",
    color: "#004aad",
    fontWeight: "700",
    marginBottom: "50px",
  },
  line: {
    width: "90px",
    height: "3px",
    backgroundColor: "#004aad",
    margin: "0 auto 50px",
    borderRadius: "2px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "30px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#f7f9fc",
    borderRadius: "14px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },
  imageWrapper: {
    width: "100%",
    height: "200px",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.4s ease",
  },
  noImage: {
    width: "100%",
    height: "100%",
    background: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#555",
    fontSize: "0.9rem",
  },
  content: {
    padding: "20px",
    textAlign: "right",
  },
  cardTitle: {
    color: "#004aad",
    fontSize: "1.3rem",
    fontWeight: "700",
    marginBottom: "10px",
  },
  description: {
    color: "#333",
    fontSize: "0.95rem",
    lineHeight: "1.6",
    marginBottom: "15px",
  },
  button: {
    backgroundColor: "#004aad",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 18px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "0.9rem",
    transition: "background 0.3s ease, transform 0.2s ease",
  },
};

export default Projects;
